export default __webpack_public_path__ + "static/es-logo-bb23cfbebdebc6dafbd0d8ca24426532.svg";